module.exports = __webpack_public_path__ + "img/弈剑.1cf8f615.png";